export const TOP_BAR_HEIGHT_SM_UP = "64px";

export const TOP_BAR_HEIGHT_SM_DOWN = "56px";
export const DRAWER_WIDTH = "300px";
export const BORDER_RADIUS = "40px";
export const BORDER_RADIUS_HALF = "20px";
